angular.module('aprima-legacy-common').factory('AppointmentTransitionToHelper',
    ['apFilterFeatureFilter', 'AppointmentScheduleTypes', function (apFilterFeature, AppointmentScheduleTypes) {
        'use strict';

        var routes = {};
        routes[AppointmentScheduleTypes.PatientVisit.id] = {
            view: 'appointment',
            edit: 'editAppointment',
            add: 'addAppointment',
            requiredFeature: AppointmentScheduleTypes.PatientVisit.requiredFeature
        };
        routes[AppointmentScheduleTypes.GroupVisit.id] = {
            view: 'groupAppointment',
            edit: 'editGroupAppointment',
            add: 'addGroupAppointment',
            requiredFeature: AppointmentScheduleTypes.GroupVisit.requiredFeature
        };
        routes[AppointmentScheduleTypes.Event.id] = {
            view: 'eventAppointment',
            edit: 'editEventAppointment',
            add: 'addEventAppointment',
            requiredFeature: AppointmentScheduleTypes.Event.requiredFeature
        };
        routes[AppointmentScheduleTypes.BlockingEvent.id] = {
            view: 'blockingEventAppointment',
            edit: 'editBlockingEventAppointment',
            add: 'addBlockingEventAppointment',
            requiredFeature: AppointmentScheduleTypes.BlockingEvent.requiredFeature
        };

        function getTransition(apptScheduleType, patientId, calendarId, edit, apptId) {
            if(!apptScheduleType) {
                return false;
            }

            var filteredRoutes = apFilterFeature(routes, 'requiredFeature');
            var transition = {
                opts: {}
            };
            var lowerScheduleType = apptScheduleType.toLowerCase();

            if(apptId) {
                transition.opts.id = apptId;
                var property = !!edit ? 'edit' : 'view';
                transition.appRoute = (filteredRoutes[lowerScheduleType] && filteredRoutes[lowerScheduleType][property]) || filteredRoutes[AppointmentScheduleTypes.PatientVisit.id][property];
            }
            else {
                transition.appRoute = (filteredRoutes[lowerScheduleType] && filteredRoutes[lowerScheduleType].add) || filteredRoutes[AppointmentScheduleTypes.PatientVisit.id].add;
            }

            if(patientId) {
                transition.opts.patientid = patientId;
            }
            if(calendarId) {
                transition.opts.calendarId = calendarId;
            }

            return transition;
        }

        return {
            getTransition: getTransition
        };
    }]);
